import axios from 'axios';
const client = process.env.REACT_APP_API_CLIENT;
const token = encodeURIComponent(window.btoa(client));
const headers = {
  'Accept': 'application/json',
  'Content-Type': 'application/json',
  'Authorization': 'Bearer '+token.toString()
}

export default axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: headers
});